import React from 'react';
import { motion } from 'framer-motion';

export default function AboutSection() {
  return (
    <section id="about" className="relative bg-black pt-40 md:pt-64 pb-24 md:pb-40 px-6 md:px-12 overflow-hidden">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,_rgba(255,255,255,0.03)_0%,_transparent_70%)] pointer-events-none" />
      
      <div className="relative z-10 max-w-6xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.6 }}
        >
          <span className="text-white/40 text-sm tracking-widest uppercase mb-12 block">
            [THE SOUL // THE DECLARATION]
          </span>
        </motion.div>

        <motion.h2
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.8, delay: 0.1 }}
          className="text-4xl md:text-6xl lg:text-7xl text-white leading-[1.1] tracking-tight font-serif"
        >
          The future belongs <br className="hidden md:block" />
          to those <em className="italic text-white/60">building it.</em>
        </motion.h2>

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="mt-16 md:mt-24 text-white/60 text-lg md:text-2xl max-w-3xl leading-relaxed font-light"
        >
          We honor the architects of tomorrow. We stand with the visionaries, the founders, and the creators who are brave enough to imagine a better future and build it today. We give their ideas a face, a voice, and a story worth remembering.
        </motion.p>
      </div>
    </section>
  );
}